import { Chip } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import { Link as RouterLink } from 'react-router-dom';
import { useMonitorLinks } from '../api/useMonitorLinks';
import { monitorPath } from '../pipr/links';
import { indicatorName } from '../pipr/types';

interface MonitorLinkChipsProps {
    eventId: string | null;
    slug: string | null;
}

export function MonitorLinkChips({ eventId, slug }: MonitorLinkChipsProps) {
    const links = useMonitorLinks(eventId, slug);
    return (
        <>
            {links.map(link => (
                <Chip
                    key={`${link.indicator}:${link.bank}:${link.meetingDate}`}
                    component={RouterLink}
                    to={monitorPath(link.bank, link.meetingDate)}
                    clickable
                    size="small"
                    variant="outlined"
                    icon={<InsightsIcon />}
                    label={`Part of: ${indicatorName(link.bank)}`}
                    aria-label={`Open ${indicatorName(link.bank)} in Monitor`}
                    sx={{
                        height: 20,
                        fontSize: '11px',
                        '& .MuiChip-icon': { fontSize: '13px' },
                    }}
                />
            ))}
        </>
    );
}
